"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IGroupChats = void 0;
const uuid_1 = require("uuid");
const mappers_1 = require("../../mappers");
const models_1 = require("../../models");
const roleAccess_1 = require("../../roleAccess/roleAccess");
const utils_1 = require("../../utils");
const BaseGroupChats_1 = require("./BaseGroupChats");
const GroupChatInfoSocketUpdateObservable_1 = require("./GroupChatInfoSocketUpdateObservable");
const GroupChatListApiUpdateObservable_1 = require("./GroupChatListApiUpdateObservable");
const GroupChatMessageReadObservable_1 = require("./GroupChatMessageReadObservable");
const GroupChatSocketAddObservable_1 = require("./GroupChatSocketAddObservable");
const GroupChatSocketDeleteObservable_1 = require("./GroupChatSocketDeleteObservable");
const GroupChatSocketHideObservable_1 = require("./GroupChatSocketHideObservable");
const GroupChatSocketUpdateObservable_1 = require("./GroupChatSocketUpdateObservable");
const GroupChatUpdateAcknowledgementStatusObservable_1 = require("./GroupChatUpdateAcknowledgementStatusObservable");
const GroupInfoChat_1 = require("./GroupInfoChat");
class IGroupChats extends BaseGroupChats_1.BaseGroupChats {
    constructor(httpAdapter, organizationUser, socketAdapter, config, userDirectory, hhnStorage) {
        super(httpAdapter, organizationUser, socketAdapter, userDirectory, hhnStorage);
        this.previousSearchText = "";
        this.isChatSearchCleared = false;
        this.isSearching = false;
        this.removeListeners = [];
        this.changeListeners = [];
        // Concurrent callers for the same chat attach to the same in-flight request.
        this.chatInfoInFlight = new Map();
        this.httpAdapter = httpAdapter;
        this.organizationUser = organizationUser;
        this.organization = organizationUser.getOrganization();
        this.socketAdapter = socketAdapter;
        this.config = config;
        this.userDirectory = userDirectory;
        this.hhnStorage = hhnStorage;
        this.groupChatUpdateAcknowledgementStatusObservable =
            new GroupChatUpdateAcknowledgementStatusObservable_1.GroupChatUpdateAcknowledgementStatusObservable(this.getChatsStorage(), organizationUser);
        this.groupChatMessageReadObservable = new GroupChatMessageReadObservable_1.GroupChatMessageReadObservable(this.getChatsStorage(), organizationUser);
        this.groupChatSocketAddObservable = new GroupChatSocketAddObservable_1.GroupChatSocketAddObservable(this.getChatsStorage(), httpAdapter, organizationUser, userDirectory);
        this.groupChatSocketUpdateObservable = new GroupChatSocketUpdateObservable_1.GroupChatSocketUpdateObservable(this.getChatsStorage(), httpAdapter, organizationUser, userDirectory);
        this.groupChatSocketDeleteObservable = new GroupChatSocketDeleteObservable_1.GroupChatSocketDeleteObservable(this.getChatsStorage(), organizationUser, hhnStorage);
        this.groupChatInfoSocketUpdateObservable =
            new GroupChatInfoSocketUpdateObservable_1.GroupChatInfoSocketUpdateObservable(this.getChatsStorage(), httpAdapter, organizationUser, socketAdapter, userDirectory);
        this.groupChatSocketHideObservable = new GroupChatSocketHideObservable_1.GroupChatSocketHideObservable(this.getChatsStorage(), httpAdapter, organizationUser, socketAdapter, userDirectory);
        this.groupChatListApiUpdateObservable =
            new GroupChatListApiUpdateObservable_1.GroupChatListApiUpdateObservable(this.getChatsStorage(), httpAdapter, organizationUser, userDirectory);
    }
    init() {
        if (this.removeListeners && this.removeListeners.length > 0) {
            throw new Error("Panic: Listeners should have been destoryed during unmount!!!");
        }
        this.removeListeners.push(this.chatMessageReadListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.deleteChatListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.chatInfoUpdateListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.updateChatListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.updateChatAcknowledgementStatusListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.addAcknowledgementStatusToChatListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.chatListUpdateListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.organizationUser
            .getNetworkManager()
            .registerSocketAuthSuccessListener((lastHeartbeatReceivedAt, abortContext) => __awaiter(this, void 0, void 0, function* () {
            yield this.syncChats(lastHeartbeatReceivedAt, abortContext);
            this.notifyChange();
        })));
    }
    destroy() {
        this.removeAllListeners();
    }
    registerChangeListener(cb) {
        const id = (0, uuid_1.v4)();
        this.changeListeners.push({ id, cb });
        return () => {
            this.changeListeners = this.changeListeners.filter(listner => listner.id !== id);
        };
    }
    notifyChange() {
        this.changeListeners.forEach(l => l.cb(this.getChats()));
    }
    removeAllListeners() {
        this.removeListeners.forEach(removeListener => removeListener());
        this.removeListeners = [];
    }
    chatMessageReadListener(cb) {
        return this.groupChatMessageReadObservable.chatMessageReadListener(cb, this.getChatType(), this.getGroupType());
    }
    updateChatAcknowledgementStatusListener(cb) {
        return this.groupChatUpdateAcknowledgementStatusObservable.updateChatAcknowledgementStatusListener(cb, this.getGroupType());
    }
    addAcknowledgementStatusToChatListener(cb) {
        return this.groupChatUpdateAcknowledgementStatusObservable.addAcknowledgementStatusToChatListener(cb, this.getGroupType(), this.organization.organizationId);
    }
    chatInfoUpdateListener(cb) {
        return this.groupChatInfoSocketUpdateObservable.chatInfoUpdateListener(cb, this.getGroupType());
    }
    updateChatListener(cb) {
        return this.groupChatSocketUpdateObservable.updateChatListener(cb, this.getChatType(), this.getGroupType(), true);
    }
    addChatListener(cb) {
        return this.groupChatSocketAddObservable.addChatListener(cb, this.getChatType(), this.getGroupType());
    }
    hideChatListener(cb) {
        return this.groupChatSocketHideObservable.hideChatListener(cb, this.getGroupType());
    }
    unHideChatListener(cb) {
        return this.groupChatSocketHideObservable.unHideChatListener(cb, this.getGroupType());
    }
    hideUnHideChat(data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.groupChatSocketHideObservable.hideUnHideChat(data);
        });
    }
    deleteChatListener(cb) {
        return this.groupChatSocketDeleteObservable.deleteChatListener(cb, this.getGroupType(), this.getChatType());
    }
    chatListUpdateListener(cb) {
        return this.groupChatListApiUpdateObservable.chatListUpdateListener(cb, this.getGroupType());
    }
    getChats() {
        return this.getChatsStorage().getChatListByType(this.getGroupType());
    }
    fetchChats() {
        return __awaiter(this, void 0, void 0, function* () {
            const groupType = this.getGroupType();
            const chatList = this.getChats();
            if (chatList.hasNext) {
                const chatRequestBody = this.buildFetchChatsRequest(groupType);
                yield this.fetchGroupChatList(chatRequestBody, groupType);
                this.notifyChange();
            }
        });
    }
    syncChats(lastHeartbeatReceivedAt, abortContext) {
        return __awaiter(this, void 0, void 0, function* () {
            const groupType = this.getGroupType();
            const chatType = this.getChatType();
            const chatRequestBody = Object.assign(Object.assign({ chatType }, (groupType !== models_1.GROUP_TYPE.HIDDEN && { groupType })), { hiddenChats: groupType === models_1.GROUP_TYPE.HIDDEN, lastSyncedAt: lastHeartbeatReceivedAt, total: 0, limit: utils_1.HHNConstants.SYNC_PAGINATION_LIMIT });
            const chatListResponse = yield this.httpAdapter
                .getChatAdapter()
                .syncGroupChatList(chatRequestBody, this.organizationUser.getOrganization().organizationId, abortContext);
            if (!chatListResponse.isAborted) {
                const newChats = (0, mappers_1.groupChatsMapper)(chatListResponse.data, this.userDirectory, this.organizationUser, this.httpAdapter);
                this.populateChatList(newChats, groupType, "PREPEND", (existingChats, newChats) => {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    const { chats, limit, hasNext, total, page } = newChats, rest = __rest(newChats, ["chats", "limit", "hasNext", "total", "page"]);
                    return Object.assign(Object.assign({}, this.pageData(existingChats)), rest);
                }, true);
            }
        });
    }
    pageData(chats) {
        return {
            limit: chats.limit,
            hasNext: chats.hasNext,
            total: chats.total,
            page: chats.page,
        };
    }
    clearChatSearch() {
        this.isChatSearchCleared = true;
        this.fetchChats();
    }
    // @ts-ignore
    getStoredChat(chatId) {
        const chatList = this.getChats();
        if (chatList) {
            const foundChat = chatList.chats.find(chat => chat.groupInfo.id === chatId);
            if (foundChat) {
                return this.getOrCreateChatFromStorage(chatId, foundChat.groupInfo, false);
            }
        }
    }
    getChat(groupId) {
        return this.getChatFromStorage(groupId);
    }
    getFreshChat(groupId, context) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const chat = this.getChatFromStorage(groupId);
            if (!chat || !((_a = chat === null || chat === void 0 ? void 0 : chat.chatInfo) === null || _a === void 0 ? void 0 : _a.members)) {
                const groupInfoResponse = yield this.fetchChatInfo(groupId, undefined, context);
                if (!groupInfoResponse.isAborted) {
                    const groupInfo = groupInfoResponse.data;
                    this.getOrCreateChatFromStorage(groupId, groupInfo, true);
                    this.notifyChange();
                }
            }
        });
    }
    addMembers(data, id) {
        return __awaiter(this, void 0, void 0, function* () {
            const { referralsToSend } = data;
            const hasAddMembersAccess = this.organizationUser.hasAccess(roleAccess_1.FEATURES.ADD_MEMBERS);
            const hasReferralsToSend = referralsToSend && referralsToSend.length > 0;
            const hasSendReferralsAccess = this.organizationUser.hasAccess(roleAccess_1.FEATURES.SEND_REFERRALS);
            try {
                if (!hasAddMembersAccess) {
                    throw new Error(utils_1.ErrorMessages.noAccessFound);
                }
                if (hasReferralsToSend && !hasSendReferralsAccess) {
                    throw new Error(utils_1.ErrorMessages.noAccessFound);
                }
                const requestPayload = Object.assign(Object.assign({}, data), { id });
                const addedMember = yield this.httpAdapter
                    .getChatAdapter()
                    .addMembers(requestPayload);
                if (!addedMember) {
                    throw new utils_1.HhnException("Error while adding members");
                }
            }
            catch (e) {
                throw new utils_1.HhnException(e);
            }
        });
    }
    getChatType() {
        return models_1.CHAT_TYPE.GROUP;
    }
    deleteChat(data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.httpAdapter.getChatAdapter().deleteGroup(data);
        });
    }
    fetchChatInfo(chatId, source, context) {
        return __awaiter(this, void 0, void 0, function* () {
            // Coalesce concurrent identical fetches onto one request. Two callers for
            // the same chat (e.g. a pending referral double-clicked) otherwise issue two
            // identical GET /user/group/<id> calls and DuplicateRequestInterceptor
            // rejects the second. Key by source too, since the detector treats `sync`
            // and non-`sync` requests as distinct.
            const key = `${chatId}:${source !== null && source !== void 0 ? source : ""}`;
            const existing = this.chatInfoInFlight.get(key);
            if (existing) {
                return existing;
            }
            const request = this.fetchChatInfoInternal(chatId, source, context);
            this.chatInfoInFlight.set(key, request);
            try {
                return yield request;
            }
            finally {
                this.chatInfoInFlight.delete(key);
            }
        });
    }
    fetchChatInfoInternal(chatId, source, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpAdapter
                .getChatAdapter()
                .getGroupInfo(chatId, source, context);
            if (!response.isAborted) {
                const mappedChatInfo = (0, mappers_1.groupInfoMapper)(response.data, this.userDirectory, this.organizationUser, this.httpAdapter, this.socketAdapter);
                return (0, utils_1.CompletedResult)(mappedChatInfo);
            }
            return utils_1.AbortedResult;
        });
    }
    getUnreadMessageCount(chatId) {
        var _a;
        return (((_a = this.hhnStorage.chatsStorage.getChatByGroupType(this.getGroupType(), chatId)) === null || _a === void 0 ? void 0 : _a.unreadCount) || 0);
    }
    getLastMessageRead(chatId) {
        const chat = this.hhnStorage.chatsStorage.getChatByGroupType(this.getGroupType(), chatId);
        if (chat) {
            return chat.lastMessageRead;
        }
        return undefined;
    }
    getIsMember(chatId) {
        const chat = this.hhnStorage.chatsStorage.getChatByGroupType(this.getGroupType(), chatId);
        if (chat) {
            // Return the stored value, treating undefined as true (user is member)
            return chat.isMember !== false;
        }
        // Return undefined to trigger fallback logic in BaseChat.isMember()
        return undefined;
    }
    touchChat(chatId) {
        return this.hhnStorage.chatStorage.touchGroupChatByType(this.getGroupType(), chatId);
    }
    getChatFromStorage(chatId) {
        return this.hhnStorage.chatStorage.getGroupChatByType(this.getGroupType(), chatId);
    }
    getOrCreateChatFromStorage(chatId, groupInfo, shouldMergeGroupInfo) {
        let chat = this.getChatFromStorage(chatId);
        if (!chat) {
            chat = new GroupInfoChat_1.GroupInfoChat(groupInfo, this.organizationUser, this.config, this.httpAdapter, this.socketAdapter, this.userDirectory, this.hhnStorage, this);
            chat.init();
            this.hhnStorage.chatStorage.addChatByType(this.getGroupType(), chat);
        }
        else {
            /*
            When a user opens a chat for the first time, getStoredChat is called and enters the 'if' condition of this method, creating the chat in storage. Then, getFreshChat is called, and we need to merge the chatInfo with the latest chatInfo returned from getFreshChat. The second time the user opens the chat, getStoredChat is called and enters the 'else' block, but we already have the latest information, so there is no need to merge or update chatInfo.
      
            Example:
            User opens chat 1:
              getStoredChat - chatStorage.chat(P) - Create
              getFreshChat - chatStorage.chat(P) <- (F) - Current (Merging) - Proposed (Overwrite)
      
            User opens chat 2
      
            User opens chat 1 again:
              getStoredChat - chatStorage.chat(F) <- Current (Overwrite) - Proposed (Do nothing)
              getFreshChat - chatStorage.chat(F) <- (F) - Current (Merging) - Proposed (Overwrite)
            */
            if (shouldMergeGroupInfo) {
                chat.updateChatInfo(Object.assign(Object.assign({}, chat.chatInfo), groupInfo));
            }
        }
        return chat;
    }
    updateVisibleToPhysician(data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.groupChatInfoSocketUpdateObservable.updateVisibleToPhysician(data);
        });
    }
    leaveAndDeleteGroup(data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.groupChatInfoSocketUpdateObservable.leaveAndDeleteGroup(data);
        });
    }
    muteNotifications(data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.groupChatInfoSocketUpdateObservable.muteNotifications(data);
        });
    }
    removeMember(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const hasRemoveMembersAccess = this.organizationUser.hasAccess(roleAccess_1.FEATURES.REMOVE_MEMBERS);
            if (!hasRemoveMembersAccess) {
                throw new Error(utils_1.ErrorMessages.noAccessFound);
            }
            yield this.httpAdapter.getChatAdapter().removeMember(data);
        });
    }
}
exports.IGroupChats = IGroupChats;
